"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = exports.Modal = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_i18next_1 = require("react-i18next");
exports.Modal = function (_a) {
    var title = _a.title, children = _a.children, onHide = _a.onHide, modalProps = tslib_1.__rest(_a, ["title", "children", "onHide"]);
    var t = react_i18next_1.useTranslation().t;
    var _b = tslib_1.__read(react_1.useState(true), 2), show = _b[0], setShow = _b[1];
    var handleOnClose = function () {
        setShow(false);
        onHide && onHide();
    };
    return (react_1.default.createElement("div", tslib_1.__assign({}, modalProps, { hidden: !show }),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", null, title),
            react_1.default.createElement("button", { onClick: handleOnClose }, t('Close'))),
        children));
};
function useModal(_a) {
    var Component = _a.Component, show = _a.show, onHide = _a.onHide, props = tslib_1.__rest(_a, ["Component", "show", "onHide"]);
    var _b = tslib_1.__read(react_1.useState(show), 2), showState = _b[0], setShow = _b[1];
    var openModal = function () { return setShow(true); };
    var closeModal = function () { return setShow(false); };
    var handleOnHide = function () {
        closeModal();
        onHide && onHide();
    };
    return {
        modal: react_1.default.createElement(Component, tslib_1.__assign({}, props, { show: showState, onHide: handleOnHide })),
        openModal: openModal,
        closeModal: closeModal,
    };
}
exports.useModal = useModal;
//# sourceMappingURL=Modal.js.map